import { render, staticRenderFns } from "./ContactListItem.vue?vue&type=template&id=5cc25c8e&scoped=true&"
import script from "./ContactListItem.vue?vue&type=script&lang=js&"
export * from "./ContactListItem.vue?vue&type=script&lang=js&"
import style0 from "./ContactListItem.vue?vue&type=style&index=0&id=5cc25c8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc25c8e",
  null
  
)

export default component.exports